import script from "./admin-signin.vue?vue&type=script&setup=true&lang=js"
export * from "./admin-signin.vue?vue&type=script&setup=true&lang=js"

import "./admin-signin.vue?vue&type=style&index=0&id=74edfa79&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74edfa79"]])

export default __exports__